import { Card, Checkbox, Button } from 'src/components/UIComponents';
import AppNavbar from 'src/components/Dashboard/Layout/AppNavbar/AppNavbar.vue'
import AppFooter from 'src/components/Dashboard/Layout/AppFooter/AppFooter.vue'
import messages from './RenewPassword.json'

export default {
  name: 'RenewPassword',

  i18n: messages,

  components: {
    Card,
    AppNavbar,
    AppFooter,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button
  },

  data() {
    return {
      form: {
        password: null,
        confirmPassword: null
      },
      data: {
        user: null
      },
      controls: {
        loading: false
      },
      error: {
        token: {
          expired: null
        },
        user: {
          disabled: null
        }
      }
    }
  },

  beforeDestroy() {
    this.closeMenu()
  },

  created() {
    if (this.$val.isDefined(this.$route.params.token)) {
      this.getUser(this.$route.params.token);
    }
  },

  methods: {
    submitForm() {
      this.$validator.validateAll().then(isValid => {
        return isValid ? this.renewPassword() : null;
      })
    },

    /**
     * test si le password est valide ou non
     */
    validatePassword() {
      this.$validator.validateAll()
    },

    /**
     * Retrouve le user associé au token
     * @param {*} token
     */
    getUser(token) {
      this.$eventHub.$emit(this.$eventHub.LOADING.START)
      this.$axios.get('rest/public/bd/password/token/' + token).then(
        response => {
          if (!response.data.actif || response.data.supprime) {
            this.error.user.disabled = true
          } else {
            this.data.user = response.data
          }
          this.$eventHub.$emit(this.$eventHub.LOADING.END)
        },
        error => {
          this.$notify.error({
            title: this.$t('notifications.renew.error.title'),
            message: this.$t('notifications.renew.error.message')
          })
          this.$eventHub.$emit(this.$eventHub.LOADING.END)
        }
      )
    },

    /**
     * Clic sur le bouton
     */
    renewPassword() {
      this.$eventHub.$emit(this.$eventHub.LOADING.START)
      const dto = this.data.user
      dto.password = this.form.password

      this.$axios.post('/rest/public/bd/password/renew/', dto).then(
        response => {
          this.data.user = null
          this.$notify.success({
            title: this.$t('notifications.renew.success.title'),
            message: this.$t('notifications.renew.success.message')
          })
          this.$eventHub.$emit(this.$eventHub.LOADING.END)
          this.$router.push({
            path: '/login'
          })
        }, error => {
          if(this.$val.isEmpty(error.attributs)){
          this.$notify.error({
            title: this.$t('notifications.renew.error.title'),
            message: this.$t('notifications.renew.error.message')
          })
        } else {
          this.$notify.error({
            title: this.$t('notifications.error.title'),
            message: this.$t('notifications.error.businessCode.' + error.businessCode + ' ') + error.attributs[0]
        })
        }
          this.$eventHub.$emit(this.$eventHub.LOADING.END)
        }
      )
    },

    gotoLogin() {
      this.$router.push({
        path: '/login'
      })
    },

    toggleNavbar() {
      document.body.classList.toggle('nav-open')
    },

    closeMenu() {
      document.body.classList.remove('nav-open')
      document.body.classList.remove('off-canvas-sidebar')
    }
  }
}
